import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { resolveUrl, API_PREFIX } from 'src/core/constants/api.constants';

const USER_API = `${API_PREFIX}/user`;

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}

  getConfirmedAiUsageDisclaimer(): Observable<boolean> {
    return this.http.get(resolveUrl(`${USER_API}/confirmed-ai-usage-disclaimer`)) as Observable<boolean>;
  }

  setConfirmedAiUsageDisclaimer(): Observable<any> {
    return this.http.post(resolveUrl(`${USER_API}/set-confirmed-ai-usage-disclaimer`), null) as Observable<any>;
  }
}
